import { type FormState } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { NumberInput, Tag } from 'ui'
import { MoreForLessTriggerEditor } from '..'
import { messages } from './messages'
import styles from './styles'

type BenefitDescriptionProps = {
  name: string
  form: FormState
  trigger: MoreForLessTriggerEditor
}

export function BenefitDescription(props: BenefitDescriptionProps) {
  const {
    name,
    form,
    trigger: { minQuantity },
  } = props

  const { $t, formatNumber } = useIntl()
  return (
    <div className={styles.description}>
      {minQuantity === undefined ? (
        <FormattedMessage
          {...messages.placeholder}
          tagName="span"
          values={{
            input: () => (
              <div className={styles.quantityInput}>
                <NumberInput
                  name={`${name}.quantity`}
                  state={form}
                  fractionDigits={0}
                  placeholder={$t(messages.quantityPlaceholder)}
                  aria-label={$t(messages.aria.quantity)}
                  max={minQuantity ?? Number.MAX_SAFE_INTEGER}
                />
              </div>
            ),
            tag: (content) => <Tag className={styles.tag}>{content}</Tag>,
          }}
        />
      ) : (
        <FormattedMessage
          {...messages.description}
          tagName="span"
          values={{
            input: () => (
              <div className={styles.quantityInput}>
                <NumberInput
                  name={`${name}.quantity`}
                  state={form}
                  fractionDigits={0}
                  placeholder={$t(messages.quantityPlaceholder)}
                  aria-label={$t(messages.aria.quantity)}
                  max={minQuantity ?? Number.MAX_SAFE_INTEGER}
                />
              </div>
            ),
            tag: (content) => <Tag className={styles.tag}>{content}</Tag>,
            minQuantity: formatNumber(minQuantity),
          }}
        />
      )}
    </div>
  )
}
